import React, { useMemo, useState } from 'react';
import Modal from '@mui/material/Modal';
import styles from './IconModal.module.scss';
import TextField from '@mui/material/TextField';
import Icon from '../../Icon';
import TextWithIcon from '../../typography/TextWithIcon';
import { customColors, iconNames } from '../../../utilities';
import { Text } from '../../typography';
import Spacer from '../../typography/Spacer';

export default function IconModal({ onClick }) {
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState('');

  const filteredIcons = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return iconNames;
    return iconNames.filter((name) => name.toLowerCase().includes(q));
  }, [search]);

  return !show ? (
    <TextWithIcon
      icon="add"
      hover
      noMargin
      iconProps={{ color: customColors.BLUE, fontSize: '1.5' }}
      weight="semiBold"
      color="accentPrimary"
      textAlign="center"
      onClick={() => setShow(true)}
      size="sm"
    >
      Add Icon
    </TextWithIcon>
  ) : (
    <Modal open={show} onClose={() => setShow(false)}>
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          borderRadius: 10,
          boxShadow: 24,
          maxHeight: '80vh',
          overflow: 'auto',
        }}
      >
        <div className={styles.content}>
          <div className={styles.container}>
            <div className={styles.header}>
              <Text noMargin weight="semiBold" size="lg">
                Select Icon
              </Text>
              <Icon
                hover
                style={{ fontSize: '2rem' }}
                onClick={() => setShow(false)}
              >
                close
              </Icon>
            </div>
            <Spacer />
            <div className={styles.paddingSm}>
              <TextField
                autoFocus
                fullWidth
                size="small"
                placeholder="Search icons..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{ mb: 2 }}
              />
            </div>

            {filteredIcons.length ? (
              <div className={styles.icons}>
                {filteredIcons.map((i) => (
                  <div className={styles.icon} key={i}>
                    <Icon
                      hover
                      style={{ fontSize: '2rem' }}
                      onClick={() => {
                        onClick(i);
                        setShow(false);
                      }}
                    >
                      {i}
                    </Icon>
                  </div>
                ))}
              </div>
            ) : (
              <Text textAlign="center">No Icons Found</Text>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}
